import AccentTitleDivider from "./accent-title-divider"

export default AccentTitleDivider
